module.exports = __webpack_public_path__ + "assets/img/05.a37c3ee8.png";